import module from './module.js'
/* Components */
import './components/component.js'
/* Services */
import './services/Terminos.js'
/* Routes */
import './routes/terminos.js'

export default module.name



// WEBPACK FOOTER //
// ./src/app/terminos/index.js